import { useQuery } from "@tanstack/react-query";
import { fetchTransactions } from "../services/transactionService";

export const useTransactions = (page = 1, search = "", status = "") => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["transactions", page, search, status],
    queryFn: () => fetchTransactions(page, search, status),
    select: (response) => {
      return {
        transactions: response.message?.transactions?.data || [],
        transactionStats: response.message || {},
        pagination: {
          current_page: response.message?.transactions?.current_page,
          total: response.message?.transactions?.total,
          per_page: response.message?.transactions?.per_page,
          last_page: response.message?.transactions?.last_page,
        },
      };
    },
  });

  return {
    transactions: data?.transactions || [],
    loading: isLoading,
    error: error?.message || null,
    transactionStats: data?.transactionStats || {},
    pagination: data?.pagination || null,
  };
};
